export default __webpack_public_path__ + "static/media/ocr_file_default.969b4577.png";